import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_203_6142)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_203_6142",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_203_6142)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12.039 17.8341C12.3079 17.8341 12.5365 17.7398 12.725 17.5511C12.9135 17.3623 13.0078 17.1334 13.0078 16.8644C13.0078 16.5956 12.9134 16.3669 12.7245 16.1784C12.5357 15.9901 12.3069 15.8959 12.038 15.8959C11.7692 15.8959 11.5405 15.9903 11.352 16.1791C11.1635 16.368 11.0693 16.5968 11.0693 16.8656C11.0693 17.1345 11.1637 17.3631 11.3525 17.5516C11.5414 17.74 11.7702 17.8341 12.039 17.8341ZM11.3308 14.2784H12.7135C12.7264 13.7196 12.7901 13.3221 12.9048 13.0861C13.0196 12.8503 13.2469 12.5645 13.5865 12.2286C14.1764 11.6555 14.5757 11.1785 14.7845 10.7976C14.9935 10.417 15.098 10.0064 15.098 9.5659C15.098 8.72173 14.8179 8.02015 14.2578 7.46115C13.6974 6.90231 12.9782 6.6229 12.1 6.6229C11.3654 6.6229 10.708 6.82065 10.128 7.21615C9.54786 7.61165 9.13277 8.14465 8.88277 8.81515L10.1423 9.3554C10.3308 8.85673 10.5891 8.49581 10.9173 8.27265C11.2454 8.04965 11.6166 7.93815 12.0308 7.93815C12.5551 7.93815 12.9753 8.08748 13.2913 8.38615C13.6074 8.68498 13.7655 9.07023 13.7655 9.5419C13.7655 9.93173 13.6395 10.2718 13.3875 10.5621C13.1357 10.8525 12.8514 11.1457 12.5348 11.4419C12.0283 11.9176 11.701 12.3359 11.553 12.6969C11.4049 13.0577 11.3308 13.5849 11.3308 14.2784ZM12.0018 21.3189C10.7544 21.3189 9.57769 21.0821 8.47152 20.6084C7.36536 20.1347 6.39719 19.483 5.56702 18.6531C4.73686 17.8233 4.08477 16.8556 3.61077 15.7499C3.13694 14.6442 2.90002 13.4678 2.90002 12.2206C2.90002 10.9566 3.13686 9.77573 3.61052 8.6779C4.08419 7.58006 4.73594 6.61606 5.56577 5.7859C6.39561 4.95573 7.36336 4.30365 8.46903 3.82965C9.57469 3.35581 10.7511 3.1189 11.9983 3.1189C13.2623 3.1189 14.4432 3.35573 15.541 3.8294C16.6389 4.30306 17.6029 4.95481 18.433 5.78465C19.2632 6.61448 19.9153 7.57806 20.3893 8.6754C20.8631 9.77273 21.1 10.9533 21.1 12.2171C21.1 13.4645 20.8632 14.6412 20.3895 15.7474C19.9159 16.8536 19.2641 17.8217 18.4343 18.6519C17.6044 19.4821 16.6409 20.1341 15.5435 20.6081C14.4462 21.082 13.2656 21.3189 12.0018 21.3189ZM12 20.0189C14.1667 20.0189 16.0084 19.2606 17.525 17.7439C19.0417 16.2272 19.8 14.3856 19.8 12.2189C19.8 10.0522 19.0417 8.21056 17.525 6.6939C16.0084 5.17723 14.1667 4.4189 12 4.4189C9.83336 4.4189 7.99169 5.17723 6.47502 6.6939C4.95836 8.21056 4.20002 10.0522 4.20002 12.2189C4.20002 14.3856 4.95836 16.2272 6.47502 17.7439C7.99169 19.2606 9.83336 20.0189 12 20.0189Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_203_6142",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgHelp;
